/**
 * Presentation rules for portfolio news detail — driven by `article_url` and `email_body` on one payload
 * (OpenAPI `PortfolioNewsDetailResponse`), not a separate variant discriminator.
 */
export const hasPortfolioNewsArticleUrl = (
  articleUrl: string | null,
): boolean => Boolean(articleUrl?.trim())

export const paragraphsFromPortfolioNewsEmailBody = (
  emailBody: string | null,
): string[] => {
  if (!emailBody?.trim()) return []
  return emailBody
    .split(/\n{2,}/)
    .map(paragraph => paragraph.trim())
    .filter(Boolean)
}
